var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"14","height":"9","viewBox":"0 0 14 9","fill":"white","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5.5 8.66034H8.5V7.24524H5.5V8.66034ZM0.25 0.169769V1.58486H13.75V0.169769H0.25ZM2.5 5.1226H11.5V3.70751H2.5V5.1226Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }